interface PlaceholderText {
  outlines: string[]
  details: string[]
}

const styles = {
  top: `
    width: 95%;
    white-space: normal;
    font-family: 'Lato', sans-serif;
    font-size: 16px;
    line-height: 24px;
  `.trim(),
  p: `
    margin-bottom: 8px;
  `.trim(),
  ul: `
    margin-left: 60px;
  `.trim(),
  li: `
    font-style: italic;

  `.trim(),
}

const blogPostPlaceholderText: PlaceholderText = {
  outlines: [
    'H1: Introduction to pet walking services',
    'H2: Why should you use a pet walking service?',
    'H2: What should you look for in a pet walking service?',
    'H2: What can you expect from a pet walking service?',
    'Call to action and conclusion',
  ],
  details: [
    'Goal: The ultimate objective of this piece.',
    'Audience: Who is reading the content.',
    'Reader purpose: Why are they reading it.',
    'Call to action: What the reader should do, think, or feel next.',
    'Sources: Publicly-available links to examples or reputable research.',
    'SEO: focus keywords, link strategies, etc. can be entered in the field to the right.',
  ],
}

const newsletterPlaceholderText: PlaceholderText = {
  outlines: [
    'H1: Headline newsletter article title',
    'H2: Second article - link to our blog',
    'H2: Third article - link to a coupon on our website',
    'Call to action and conclusion',
  ],
  details: [
    'Goal: The ultimate objective of this piece.',
    'Audience: Who is reading the content.',
    'Reader purpose: Why are they reading it.',
    'Call to action: What the reader should do, think, or feel next.',
    'Sources: Publicly-available links to examples you love, or reputable research.',
    "Whether you'd like short summaries of content you're highlighting.",
  ],
}

const pressReleasePlaceholderText: PlaceholderText = {
  outlines: [
    'H1: Introduction to your new pet walking services business',
    'H2: Announcement details - about the business',
    'H2: Quotes from happy customers',
    'H2: What can you expect from a pet walking service?',
    'Call to action and press contact',
  ],
  details: [
    'Goal: The ultimate objective of this piece.',
    'Audience: Who is reading the content.',
    'Benefits: Why this matters to the reader.',
    'Specifics: Event or product announcement details.',
    "Quotes: Any quote(s) you'd like included.",
    'Call to action: What the reader should do, think, or feel next.',
    'Press contact or links for more information.',
  ],
}

const websiteContentPlaceholderText: PlaceholderText = {
  outlines: [
    'H1: Page title - About our services',
    'H2: Why should you use a pet walking service?',
    'H2: What should you look for in a pet walking service?',
    'H2: What can you expect from a pet walking service?',
    'Call to action and conclusion',
  ],
  details: [
    'Goal: The ultimate objective of this piece.',
    'Audience: Who is reading the content.',
    'Reader purpose: Why are they reading it.',
    'Call to action: What the reader should do, think, or feel next.',
    'Sources: Publicly-available links to examples you love, or reputable research.',
    'SEO: focus keywords, link strategies, etc. can be entered in the field to the right.',
  ],
}

const whitePaperPlaceholderText: PlaceholderText = {
  outlines: [
    'H1: Introduction to pet walking services',
    'H2: Why do experts say you should use a pet walking service?',
    'H2: What should you look for in a pet walking service?',
    'H2: More supporting evidence & quotations',
    'Call to action and conclusion',
  ],
  details: [
    'Goal: The ultimate objective of this piece.',
    'Audience: Who is reading the content.',
    'Reader purpose: Why are they reading it.',
    'Call to action: What the reader should do, think, or feel next.',
    "Specifics: Details on the solution you're providing.",
    'Sources: Publicly-available links to examples you love, or reputable research.',
    'SEO: Focus keywords, link strategies, etc. can be entered in the field to the right.',
  ],
}

const eBookSegmentPlaceholderText: PlaceholderText = {
  outlines: [
    'H1: Introduction to pet walking services',
    'H2: Why should you use a pet walking service?',
    'H2: What should you look for in a pet walking service?',
    'H2: What can you expect from a pet walking service?',
    'Conclusion',
  ],
  details: [
    'Goal: The ultimate objective of the entire book, and how it will be used.',
    'Section: Where this request fits into the eBook as a whole.',
    'Audience: Who is reading the book.',
    'Reader purpose: Why are they reading it.',
    'Call to action: What the reader should do, think, or feel next.',
    'Sources: Publicly-available links to examples you love, or reputable research.',
  ],
}

const baseHTMLString = (placeholder: PlaceholderText) => `
  <div style="${styles.top}">
    <p style="${styles.p}">
      For best results, include an outline for your desired content. For example...
    </p>
    <ul class="pb-2"  style="${styles.ul}">
      ${placeholder.outlines
        .map((outline) => `<li style="${styles.li}">${outline}</li>`)
        .join('\n')}
    </ul>
    <p style="${styles.p}">
      Remember to give key details that will help a writer meet your goals. For example...
    </p>
    <ul style="${styles.ul}">
      ${placeholder.details.map((detail) => `<li>${detail}</li>`).join('\n')}
    </ul>
  </div>
`

const standAloneVideoHelpString: string = `
  <div style="${styles.top}">
    <p style="${styles.p}">
      Give the production team a useful description in order to receive the best video. Don't forget to include:
    </p>
    <ul style="${styles.ul}">
      <li>a call to action (will display at end)</li>
      <li>musical preferences (style? instruments? tempo?)</li>
      <li>image preferences (you may link to your library at right)</li>
      <li>video length preferences</li>
      <li>words or phrases we shouldn't use</li>
    </ul>
  </div>
`

const placeholderString = {
  1: baseHTMLString(blogPostPlaceholderText),
  2: baseHTMLString(newsletterPlaceholderText),
  3: baseHTMLString(pressReleasePlaceholderText),
  4: baseHTMLString(websiteContentPlaceholderText),
  5: baseHTMLString(whitePaperPlaceholderText),
  6: baseHTMLString(eBookSegmentPlaceholderText),
}

export { placeholderString, standAloneVideoHelpString }
